module.exports = __webpack_public_path__ + "media/images/homes/Multipleproductvariants-2286ab29e01ad64610b04457c881ab13.png";